import { render, staticRenderFns } from "./CreateClientBtn.vue?vue&type=template&id=397c2a36"
import script from "./CreateClientBtn.vue?vue&type=script&lang=ts"
export * from "./CreateClientBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports